import { useEffect, useCallback, useRef } from 'react';

export default callback => {
  const targetElement = useRef(null);
  const handleClickOutside = useCallback(
    ({ target: eventTarget }) => {
      const element = !!targetElement && targetElement.current;

      if (!element) return;

      if (element.contains(eventTarget)) return;

      if (typeof callback !== 'function') return;

      callback();
    },
    [targetElement, callback],
  );

  useEffect(() => {
    window.addEventListener('click', handleClickOutside);
    return () => window.removeEventListener('click', handleClickOutside);
  }, [handleClickOutside]);

  return targetElement;
};
